import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import AddNewProduct from ".";
import API_KEY from "api";

export default function AddProductFromCategory() {
  const params = useParams();
  const [categoryData, setCategoryData] = useState(null);
  function fieldSorter(fields) {
    return function (a, b) {
      return fields
        .map(function (o) {
          var dir = 1;
          if (o[0] === "-") {
            dir = -1;
            o = o.substring(1);
          }
          if (a[o] > b[o]) return dir;
          if (a[o] < b[o]) return -dir;
          return 0;
        })
        .reduce(function firstNonZeroValue(p, n) {
          return p ? p : n;
        }, 0);
    };
  }
  const getCategoryData = (id) => {
    API_KEY.URL.get(`${API_KEY.path.attributes}`, {
      params: {
        fields: "*,attributes.attributes_id.*",
      },
    })
      .then((res) => {
        var tab_keys = {
          production: 0,
          internal: 1,
          vendor: 2,
          exclusive: 3,
          production_detail: 4,
        };
        var attributes = res?.data?.data
          ? res?.data?.data.map(function (e) {
              e.sorter = tab_keys[e.tabname];
              e.priority = e.priority;
              // console.log(e.sorter);
              return e;
            })
          : [];
        attributes.sort(fieldSorter(["sorter", "-priority"]));
        // console.log(attributes);
        res.data.data.attributes = attributes;
        setCategoryData(res?.data?.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    params?.id && getCategoryData(params?.id);
  }, [params]);

  if (categoryData) {
    return (
      <div>
        <AddNewProduct
          page={"productByCategory"}
          initalCategoryData={categoryData}
          formData={{ secondary_category_id: parseInt(params?.id) }}
        />
      </div>
    );
  }
  return <div></div>;
}
